import C from '../../common/constantes';
import messageDialog from "../../../components/message-dialog.vue";
import routeResume from "../../../components/route-resume.vue";
import auth from '../../../services/auth';
import Tolls from '../../../services/toll';
import { cpfCnpj } from '../../../validators/cpfCnpj';
import moment from 'moment'
import { addDays, addMinutes, format, isAfter, isBefore, setHours, setMinutes } from 'date-fns';

export default {
  data() {
    const currentDate = new Date();
    const minDate = addMinutes(currentDate, 10);
    const maxDate = setMinutes(setHours(addDays(currentDate, 30), 23), 59);
    const formattedMinDate = format(minDate, "yyyy-MM-dd'T'HH:mm");
    const formattedMaxDate = format(maxDate, "yyyy-MM-dd'T'HH:mm");

    return {
      minDate: formattedMinDate,
      maxDate: formattedMaxDate,
      dataInicioViagem: formattedMinDate,
      dataFimViagem: '',
      loading: undefined,
      priceTolls: {},
      listValePedagio: {},
      docs: 'cte',
      expirationDays: 1,
      taxIdNumber: undefined,
      dataViagemInicial: undefined,
      dataViagemFim: undefined,
      user: auth.currentUser,
      status:'',
      axesId: 2,
      step: 0,
      plate: undefined,
      vehicle: undefined,
      messageError: undefined,
      routeSelected: undefined,
      msgError: undefined,
      docEmbarqueNum: undefined,
      docEmbarqueTipo: undefined,
      search: '',
      filterActive: true,
      forceTransfer: false,
      showForceTransfer: false,
      motorista: '',
      externalId: '',
      campo1: '',
      campo2: '',
      campo3: '',
      campo4: '',
      campo5: '',
      enableRNTRC: false,
      rntrcDocument: '',
      rntrcOwnerName: '',
      nomeTransportador: '',
      documentoTransportador: '',
      rntrcRejected: false,
      rntrcExceptionCreated: false,
      createException: false,
      rntrcRejectedDocument: '',
      rntrcRejectedName: '',
      idIntern: undefined
    }
  },
  watch: {
    dataFimViagem(value){
      this.dataViagemFim = value;
    },
    filterActive(){
      this.filter()
    }
  },
  computed: {
    axes(){
      return C.Axes;
    },
    contractId(){
      return this.$route.params.contractId;
    },
    emissor(){
      //
      if(this.user.person)
        return this.user.person.name + ' ' + this.user.person.lastName
      else if(this.user.company)
        return this.user.company.companyName;
    },
    transportador(){
      if (this.nomeTransportador) return this.nomeTransportador;
      if(this.vehicle.companyName)
        return this.vehicle.companyName;
      else if(this.vehicle.personName)
        return this.vehicle.personName + ' ' + this.vehicle.personLastName;
    },

    category(){
      return _.find(C.Axes, (o)=>{
        return o.category_artesp_id == this.axesId;
      }).caption;
    },

    expirationDate(){

      return moment().add(parseInt(this.expirationDays), 'd')
    },

    routeOrigin(){
      if (this.routeSelected) {
        const origin = this.routeSelected.points.find(e => e.type == 'origin');
        return origin ? origin.address : '';
      }

      return '';
    },
    routeDestination(){
      if (this.routeSelected) {
        const destination = this.routeSelected.points.find(e => e.type == 'destination');
        return destination ? destination.address : '';
      }

      return '';
    }
  },
  methods: {
    findPlate(){
      this.msgError = undefined;

      const returnCheckPlate = this.checkPlate(this.plate);

      if(returnCheckPlate != 0) {
        switch(returnCheckPlate) {
          case 1: this.msgError = 'Falha, informe uma placa.';
                  break;
          case 2: this.msgError = 'Falha, placa inválida.'
                  break;
        }
        return;
      }

      this.loading = Tolls.getVehicleDataVp(this.plate).then(response => {
        if (!response) {
          this.vehicle = undefined;
          this.msgError = 'Não foi possível obter os dados do veículo. Tente novamente.';
          return;
        }

        this.vehicle = response;
        this.axesId = response.categoryArtespId;

        this.resetRntrcException();

        if (!response.rntrc) {
          this.showRNTRC();
        } else if (this.isRntrcRejected(response.rntrc)) {
          this.handleRntrcRejection(response);
        }

        this.msgError = undefined;
      }).catch(err => {

        this.msgError = (err && err.data && err.data.status && err.data.status.message)
          || 'Não foi possível consultar a ANTT no momento. Tente novamente mais tarde.';
        this.vehicle = undefined;
      });
    },
    checkPlate(plate) {
      if(plate == '' || plate == undefined) {
        return 1; // nenhuma placa informada
      } else if (plate.toString().replace("-", '').length != 7) {
        return 2; // faltando caractere na placa
      } else {
        return 0; // ok
      }
    },
    filter:_.debounce(function(){
      this.search = this.search.toUpperCase();

      if(!this.allRoutes)
        return;

      if (this.search == '') {
        this.routes = this.allRoutes;
        this.page = this.page.itemCount(this.routes.length);
        return;
      }
      this.routes = this.allRoutes.filter(value => {
        let a = value.name.toUpperCase().indexOf(this.search) >= 0 || value.flexField1.toUpperCase().indexOf(this.search) >= 0 || value.flexField2.toUpperCase().indexOf(this.search) >= 0;
        let b =_.filter(value.points, (o) => {

          return o.address && o.address.toUpperCase().indexOf(this.search) >= 0;
        }).length > 0;

        return a || b;
      });

      this.page = this.page.itemCount(this.routes.length);
    },400),
    nextStep() {
      this.msgError = undefined;
      this.cancelRNTRC();
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      switch(this.step){
        case 0:
          const dateFormat = 'dd/MM/yyyy HH:mm';

          if (!this.dataFimViagem) {
            this.msgError = 'Informe a data de fim da viagem.';
            return;
          }

          if (!this.dataInicioViagem) {
            this.msgError = 'Informe a data de início da viagem.';
            return;
          }

          if (isBefore(new Date(this.dataInicioViagem), new Date(this.minDate))) {
            this.msgError = 'Data de início da viagem deve ser superior a ' + format(new Date(this.minDate), dateFormat) + '.';
            return;
          }

          if (isAfter(new Date(this.dataFimViagem), new Date(this.maxDate))) {
            this.msgError = 'Data de fim da viagem deve ser anterior a ' + format(new Date(this.maxDate), dateFormat) + '.';
            return;
          }

          if (isBefore(new Date(this.dataFimViagem), new Date(this.dataInicioViagem))) {
            this.msgError = 'Data de fim da viagem deve ser superior a data de início da viagem.';
            return;
          }

          if(!this.routeSelected){
            this.msgError = 'Por favor escolha uma rota';
            return;
          }
          this.step += 1;
          break;
        case 1:
          if(!this.plate || this.plate.trim()=='' || !this.vehicle){
            this.msgError = 'Por favor informe a placa';
            return;
          }

          if (this.rntrcRejected && !this.createException) {
            this.msgError = 'Para continuar, selecione uma ação válida.';
            return;
          }


          /*
          if(!this.vehicle.rntrc || this.vehicle.rntrc.trim()==''){
            this.msgError = 'Veículo não possui RNTRC';
            return;
          }
          */
          if(this.vehicle.partner){
            this.msgError = 'Não é possivel emitir Vale-pedágio para veículo ' + this.vehicle.partner;
            return;
          }

          let tolls = [];

          this.routeSelected.tollFees.forEach(element => {
                element.radius = element.radius == "" ? 0 : element.radius;
                tolls.push(element);
              });
          //
          //this.loading = Tolls.getPriceTolls({tolls: this.routeSelected.tollFees, axes: this.axesId}).then(r => {
            this.loading = Tolls.getPriceTolls({tolls , axes: this.axesId}).then(r => {
            this.priceTolls = r;

          }).catch(err => {

          });
          this.step += 1;
          break;
        case 2:
          this.step += 1;
          break;
      }
    },
    backStep() {
      this.cancelRNTRC();

      if(this.step == 0){
        this.cancelar();
        return;
      }

      this.msgError = undefined;
      $('body').stop().animate({
        scrollTop: 0
      }, '500', 'swing');
      this.step -= 1;
    },
    cancelar() {
      messageDialog.show({
        title: 'Cancelar Vale-pedágio',
        message: 'Deseja cancelar essa emissão de vale-pedágio?',
        type: 'OK-CANCEL-ADHESION'
      }).then(res => {
        if(res == 'OK'){
          this.$router.push({name: 'plans'});
        }
      });

    },
    doRequest() {
      this.msgError = undefined;
      if(this.priceTolls.totalValue == 0){
         this.msgError = 'Ocorreu um problema, o valor total dos pedágios não pode ser ZERO';
         return;
      }

      if (this.rntrcRejected && this.createException && !this.rntrcExceptionCreated) {
        const promise = this.criarExcecao()
          .then(() => this.emitirValePedagio())
          .catch(() => {});
        this.$store.dispatch('loading', promise);
        return;
      }

      this.$store.dispatch('loading', this.emitirValePedagio());
    },
    emitirValePedagio() {
      let req = {
        placaVeiculo: this.plate,
        routeId: this.routeSelected.routeId,
        version: this.routeSelected.version,

        CNPJTransportador: this.documentoTransportador,
        transportador: this.nomeTransportador,

        // expirationVP: F.date(this.expirationDate, 'YYYY-MM-DD'),
        expirationVP: format(new Date(this.dataFimViagem), 'yyyy-MM-dd HH:mm:ss'),
        startVP: format(new Date(this.dataInicioViagem), 'yyyy-MM-dd HH:mm:ss'),
        // docEmbarqueTipo: this.docEmbarqueTipo,
        // docEmbarqueNum: this.docEmbarqueNum,
        docEmbarqueTipo: '',
        docEmbarqueNum: '',
        CPFCNPJEmbarcador: this.user.taxIdNumber,
        categoryArtespId: this.axesId,
        forceTransfer: this.forceTransfer ? 1 : 0,
        motorista: this.motorista,
        externalId: this.externalId,
        extraInfoVP: {
          campo1: this.campo1,
          campo2: this.campo2,
          campo3: this.campo3,
          campo4: this.campo4,
          campo5: this.campo5,
        },
        contratoOrig: this.contractId,
        excecaoRntrc: this.rntrcExceptionCreated ? 1 : 0
      };


      return Tolls.insertValePedagio(req).then(res => {
        this.idIntern = res.idIntern;
        messageDialog.show({
          title: 'Sucesso',
          message: 'Vale-pedagio emitido com sucesso',
          type: 'OK'
        }).then(res => {
          if(res == 'OK'){
            this.$router.push({name: 'summary-accompaniment', params: {contractId: this.contractId, idVP: this.idIntern}});
            // this.$router.push({name: 'accompaniment', params: {contractId: this.contractId}});
          }
        });


      }).catch(err => {
        if (  err.data.status && (
              err.data.status.code === 9203 ||
              err.data.status.code === 9205 ||
              err.data.status.code === 9209 ||
              err.data.status.code === 9210 ||
              err.data.status.code === 9223 ||
              err.data.status.code === 9225
            )
        ) {
          this.enableRNTRC = true;
        }

        if(err.data.status.code == 9898){
          document.getElementById("externalId").style.borderColor="#FF0000"
        }

        this.msgError = err.data.status.message;

        if(err.data.status && err.data.status.code == 500){
          this.showForceTransfer = true;
        }
      });
    },
    goToStep(value) {
      this.code = undefined;
      this.step = value;
    },

    cancelRNTRC() {
      this.enableRNTRC = false;
      this.rntrcDocument = '';
      this.rntrcOwnerName = '';
    },

    showRNTRC() {
      this.enableRNTRC = true;
    },

    validateDocument() {

      if (!this.rntrcOwnerName) {
        this.msgError = "Favor informar Nome/Razão Social.";
        return;
      }

      if (!this.rntrcDocument) {
        this.msgError = "Favor informar Documento.";
        return;
      }

      if (!cpfCnpj.validate(this.rntrcDocument)) {
        this.msgError = "Documento inválido!";
        return;
      }

      const documentoInformado = this.rntrcDocument;
      const nomeInformado = this.rntrcOwnerName;

      this.loading = Tolls.getVehicleDataVp(this.plate, this.rntrcDocument).then(response => {
        if (!response) {
          this.msgError = 'Não foi possível obter os dados do transportador. Tente novamente.';
          return;
        }

        this.vehicle = response;
        this.axesId = response.categoryArtespId;
        this.enableRNTRC = false;

        const rntrcValidado = response && response.rntrc && !this.isRntrcRejected(response.rntrc);

        if (rntrcValidado){
          if (this.rntrcOwnerName) {
            this.nomeTransportador = this.rntrcOwnerName.toUpperCase();
          }

          if (this.rntrcDocument) {
            this.documentoTransportador = this.rntrcDocument;
          }
        }

        this.rntrcDocument = '';
        this.rntrcOwnerName = '';
        this.msgError = undefined;

        if (rntrcValidado) {
          this.resetRntrcException();
          messageDialog.show({
            title: 'Sucesso',
            message: 'Documento validado com sucesso.',
            type: 'OK'
          });
        } else {
          this.handleRntrcRejection(response, documentoInformado, nomeInformado);
          messageDialog.show({
            title: 'Falha validação',
            message: 'Transportador não regularizado na ANTT (RNTRC)',
            type: 'OK'
          });
        }
      }).catch(err => {
        this.msgError = (err && err.data && err.data.status && err.data.status.message)
          || 'Não foi possível consultar a ANTT no momento. Tente novamente mais tarde.';
      });
    },

    isRntrcRejected(rntrc) {
      return !!rntrc && rntrc.includes('RNTRC');
    },


    handleRntrcRejection(response, documento, nome) {
      this.rntrcRejected = true;
      this.rntrcExceptionCreated = false;
      this.createException = false;
      this.enableRNTRC = false;

      this.rntrcRejectedDocument = documento
        || this.documentoTransportador
        || (response && response.taxIdNumber)
        || '';

      this.rntrcRejectedName = (nome
        || this.nomeTransportador
        || (response && response.companyName)
        || (response && response.personName ? (response.personName + ' ' + (response.personLastName || '')).trim() : '')
        || '');
    },

    resetRntrcException() {
      this.rntrcRejected = false;
      this.rntrcExceptionCreated = false;
      this.createException = false;
      this.rntrcRejectedDocument = '';
      this.rntrcRejectedName = '';
    },


    criarExcecao() {
      const cpfCnpj = this.rntrcRejectedDocument
        || this.documentoTransportador
        || (this.vehicle && this.vehicle.taxIdNumber)
        || '';

      const nomeRazSocial = (this.rntrcRejectedName
        || this.nomeTransportador
        || (this.vehicle && this.vehicle.companyName)
        || (this.vehicle && this.vehicle.personName ? (this.vehicle.personName + ' ' + (this.vehicle.personLastName || '')).trim() : '')
        || '').toUpperCase();

      if (!cpfCnpj) {
        this.msgError = 'Não foi possível identificar o documento do transportador para criar a exceção.';
        return Promise.reject(new Error(this.msgError));
      }

      const req = {
        plate: this.plate,
        cpfCnpj: cpfCnpj,
        nomeRazSocial: nomeRazSocial,
        description: 'Exceção de RNTRC criada pelo embarcador via Site Move Mais.'
      };

      return Tolls.cadastrarExcecao(req).then(res => {
        if (res && res.status && res.status.code !== 0) {
          this.msgError = res.status.message || 'Falha ao registrar exceção.';
          return Promise.reject(new Error(this.msgError));
        }

        this.rntrcExceptionCreated = true;
        this.documentoTransportador = cpfCnpj;
        this.nomeTransportador = nomeRazSocial;
        this.msgError = undefined;
      }).catch(err => {
        this.msgError = (err && err.data && err.data.status && err.data.status.message)
          || this.msgError
          || 'Falha ao registrar exceção.';
        return Promise.reject(err);
      });
    }

  },
  components: {
    routeResume
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/toll-ticket/toll-ticket.js